export enum SubmissionBarKind {
    DrawerBasic = "DrawerBasic",
    DrawerWizard = "DrawerWizard",
    DrawerAttendance = "DrawerAttendance",
    DialogBasic = "DialogBasic",
    WidgetBasic = "WidgetBasic",
    WidgetStepper = "WidgetStepper",
    DialogDanger = "DialogDanger"
}
